<template>
  <div class="container stretch liu-hai-pin">
    <navComp
      ref="navComp"
      :navList="navList"
      :activeTab.sync="activeTab"
      :subActiveTab.sync="subActiveTab"
      @changeTab="changeActiveTab"
      @clickDisabledSubTab="clickDisabledCompetition"
    />
    <div class="right-content">
      <!-- <gamblePopComp :show="true"/> -->
      <topInfoComp
        v-if="activeTab != 'gameLog'"
        :rightBtnNameList="rightBtnNameList"
        @clickBtn="clickRightTopBtn"
        @showRule="getRuleText"
        ref="topInfo"
      />
      <quizPage v-if="activeTab == 'game'" @gotoGetGold="gotoGetGold" />
      <shopPage v-if="activeTab == 'shop'" />
      <rankPage v-if="activeTab == 'rank'" @showQuizLog="showQuizLog" />
      <quizLogPage
        v-if="activeTab == 'gameLog'"
        @goBack="gotoRank"
        :uid="showQuizLogUid"
      />
      <showAllTeamPop
        v-if="showAllTeam"
        :gameId="gameId"
        @close="showAllTeam = false"
      />
      <exChangeLog v-if="showExChangeLog" @close="showExChangeLog = false" />
      <gamblePopComp boxType="title" :show="!!ruleText" @close="ruleText = ''">
        <div class="rule-box">
          <div class="rule-text">
            <template v-for="(line, index) in ruleTextLineList">
              {{ line
              }}<br :key="index" v-if="index < ruleTextLineList.length - 1" />
            </template>
          </div>
        </div>
      </gamblePopComp>
      <gamblePopComp
        boxType="box"
        :show="showNoCurGame"
        @close="showNoCurGame = false"
      >
        <div class="no-cur-game">
          <div class="text">{{ getDict(303) }}</div>
          <div class="button-bg done-btn" @click="showNoCurGame = false">
            {{ getDict(302) /*确 定*/ }}
          </div>
        </div>
      </gamblePopComp>
      <gamblePopComp
        v-if="!!popMessage"
        :show="true"
        boxType="box"
        @close="popMessage = ''"
      >
        <div class="popMsgBox">
          <span>{{ popMessage }}</span>
        </div>
      </gamblePopComp>
      <portal-target
        name="gamblePageRightContentPortal"
        class="portal"
      ></portal-target>
    </div>
    <portal-target name="gamblePagePortal" class="portal"></portal-target>
    <!-- <div class="pop-mask"></div> -->
  </div>
</template>

<script>
import {
  getDict,
  axios,
  formatDate,
  getPageLevelMixin,
  serverApi,
} from "../../common";
import { mapState, mapGetters } from "vuex";
import alert from "../../components/alert";
import store from "@/store";
import navComp from "./comps/nav";
import topInfoComp from "./comps/top-info";
import titleSwitch from "./comps/title-switch";
import showAllTeamPop from "./comps/show-all-team";
import exChangeLog from "./comps/exchange-log";

import gamblePopComp from "./comps/gamble-pop-comp";

import quizPage from "./page/quiz-page";
import shopPage from "./page/shop-page";
import rankPage from "./page/rank-page";
import quizLogPage from "./page/quiz-log-page";

export default {
  name: "gamblePage",
  mixins: [getPageLevelMixin],
  props: {},
  data() {
    return {
      pageLevel: 1,
      popMessage: "",

      activeTab: "game",
      subActiveTab: undefined,

      showAllTeam: false,
      showExChangeLog: false,
      ruleText: "",
      showNoCurGame: false,

      // rightBtnNameList:[{
      //   name:'查看全部队伍',
      //   key:'',
      // }],
      rightTopBtnMap: {
        game: {
          btnList: [
            {
              name: getDict(290) /* "查看全部队伍" */,
              key: "btn1",
            },
          ],
          actionMap: {
            btn1: "showAllTeam",
          },
        },
        shop: {
          btnList: [
            {
              name: getDict(291) /* "兑换记录" */,
              key: "btn1",
            },
          ],
          actionMap: {
            btn1: "showExChangeLog",
          },
        },
      },

      navList: [
        {
          name: getDict(292) /* "赛事竞猜" */,
          key: "game",
          subNavList: [
            /* {
              name: "1234567890111111111111111111111",
              key: "test1",
            },
            {
              name: "1234567890",
              key: "test2",
            },
            {
              name: "1234567890",
              key: "test3",
            },
            {
              name: "1234567890",
              key: "test4",
            },
            {
              name: "1234567890",
              key: "test5",
            },
            {
              name: "1234567890",
              key: "test6",
            },
            {
              name: "1234567890",
              key: "test7",
            },
            {
              name: "1234567890",
              key: "test8",
            },
            {
              name: "1234567890",
              key: "test9",
            },
            {
              name: "1234567890",
              key: "test0",
            }, */
          ],
        },
        {
          name: getDict(293) /* "兑换商城" */,
          key: "shop",
        },
        {
          name: getDict(294) /* "竞猜排行榜" */,
          key: "rank",
        },
        {
          name: getDict(295) /* "竞猜记录" */,
          key: "gameLog",
        },
      ],

      showQuizLogUid: undefined,
      //===================api接口数据

      gameId: undefined,
      _userInfo: null,
      // {
      //   uid:undefined,
      //   name:undefined,
      //   icon:undefined,
      //   gold:undefined,
      //   win_count:undefined,
      //   quiz_count:undefined,
      //   win_gold:undefined,
      //   quiz_gold:undefined,
      //   hit_rate :undefined,
      //   recycle_rate :undefined,
      //   gold_rank :undefined,
      //   hit_rate_rank:undefined,
      //   recycle_rate_rank:undefined,

      // }
    };
  },
  computed: {
    ...mapState(["gambleObject"]),
    ...mapGetters([
      "gambleCompetitionList",
      "gambleCurCompetition",
      "gambleNoCurGame",
      "nowTs",
    ]),
    rightBtnNameList() {
      let activeObj = this.rightTopBtnMap[this.activeTab];
      return activeObj ? activeObj.btnList : [];
    },

    userInfo() {
      if (this._userInfo) {
        return this._userInfo;
      } else {
        return {};
      }
    },
    // activeGameId(){
    //   if(this.activeTab != 'game'){
    //     return null;
    //   }
    //   return this.subActiveTab;
    // },
    ruleTextLineList() {
      if (!this.ruleText) {
        return [];
      }
      let list = this.ruleText.split("\n");
      return list.map((line) => line.replace(/\s/g, "\u3000"));
    },
  },
  watch: {
    gambleCompetitionList() {
      let gameNav = this.navList.find((nav) => nav.key == "game");
      if (gameNav) {
        gameNav.subNavList = this.gambleCompetitionList.map((item) => ({
          // name: item.name,
          key: item.cid,
          colorTextList: [
            {
              text: getDict(
                [
                  0, 296 /* 未開始 */, 297 /* 競猜中 */, 298 /* 直播中 */,
                  299 /* 已結束 */,
                ][item.state],
                [item.start_ts ? formatDate(item.start_ts * 1000, "M.D") : ""]
              ),
              color: ["", "#82ad94", "#ffde7a", "#dc9f5c", "#afafaf"][
                item.state
              ],
            },
            {
              text: item.name,
            },
          ],
          disabled: item.quiz_ts * 1000 > this.nowTs,
        })); //.concat(gameNav.subNavList);
        if (this.activeTab == "game") {
          this.calcCurlGame();
        }
      }
    },
    activeTab(val, oldval) {
      if (val == "game" && oldval != "game") {
        this.calcCurlGame();
      }
    },
    subActiveTab() {
      if (this.activeTab != "game") {
        return;
      }
      store.commit("gambleSetActiveCompetitionId", this.subActiveTab);
    },
    gambleNoCurGame() {
      this.showNoCurGame = true;
    },
  },
  methods: {
    getDict,
    calcCurlGame() {
      this.subActiveTab = this.gambleCurCompetition
        ? this.gambleCurCompetition.cid
        : undefined;
      if (this.$refs.navComp) {
        this.$nextTick(() => {
          this.$refs.navComp.focusNav();
        });
      }
    },
    clickRightTopBtn(key) {
      let activeObj = this.rightTopBtnMap[this.activeTab];
      if (activeObj) {
        if (activeObj.actionMap[key]) {
          this[activeObj.actionMap[key]] = true;
        }
      }
    },
    clickDisabledCompetition(key) {
      let competition = this.gambleCompetitionList.find((c) => c.cid == key);
      if (competition) {
        this.popMessage = formatDate(
          competition.quiz_ts * 1000,
          getDict(304, ["MM", "DD", "HH:mm"]) /*竞猜开始时间：DD日HH时*/
          // '本試合の予想はMM月DD日HH:mmより開始します'
        );
      }
    },
    changeActiveTab() {
      this.showQuizLogUid = undefined;
    },
    showQuizLog(user) {
      if (user && user.uid) {
        this.showQuizLogUid = user.uid;
      } else {
        this.showQuizLogUid = undefined;
      }
      this.activeTab = "gameLog";
    },
    gotoRank() {
      this.showQuizLogUid = undefined;
      this.activeTab = "rank";
    },
    gotoGetGold() {
      this.$refs.topInfo && this.$refs.topInfo.popTask();
    },

    //------------api部分
    async getCurrentGameId() {
      let res = await serverApi.get("current_game");
      if (res.code == 200) {
        this.gameId = res.data.gid;
      }
    },
    async getUserInfo() {
      let res = await serverApi.get("user");
      if (res.code == 200) {
        this._userInfo = res.data;
      }
    },
    async getRuleText() {
      let path = "rule";
      // if(this.activeTab == 'shop'){
      //   path = 'exchange_rule';
      // }
      let res = await serverApi.get(path);
      if (res.code == 200) {
        this.ruleText = res.data.rule;
      }
    },
  },
  components: {
    alert,
    navComp,
    topInfoComp,
    titleSwitch,
    quizPage,
    showAllTeamPop,
    shopPage,
    exChangeLog,
    rankPage,
    quizLogPage,
    gamblePopComp,
  },
  mounted() {},
  created() {
    // this.getCurrentGameId();
    // this.getUserInfo();
    store.dispatch("gambleGetCurrentGameId");
    store.dispatch("gambleGetUserInfo");

    this.showNoCurGame = this.gambleNoCurGame;
  },
};
</script>

  <style lang="scss" scoped>
.container {
  display: flex;
  flex: 1;
  // height: 100%;
  position: relative;
  &.stretch {
    align-items: stretch;
  }

  height: 0; //解决部分设备商品列表超框问题
  flex: 1; //解决部分设备商品列表超框问题

  .right-content {
    min-width: 0;
    $padding: 0.3rem;
    flex: 1;
    // height: 100%;
    padding: $padding $padding 0;
    display: flex;
    flex-direction: column;
    position: relative;

    // z-index: 0;
    /deep/.gamble-page-right-content-pddding {
      padding-left: $padding;
      padding-right: $padding;
    }
  }

  .portal {
    height: 0;
    width: 0;
  }

  .rule-box {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 0.3rem;

    .rule-text {
      min-width: 0;
      min-height: 0;
      // width: 100%;
      // max-width: 7rem;
      // max-height: 3rem;
      top: 0;
      left: 0;
      margin-bottom: 0.2rem;
      color: #fff;
      font-size: 0.22rem;
      overflow-y: auto;
      word-break: break-all;
    }
  }

  .no-cur-game {
    display: flex;
    flex-direction: column;
    position: absolute;
    height: 100%;
    width: 100%;
    align-items: center;

    .text {
      text-align: center;
      font-size: 0.3rem;
      color: #fff;
      flex: 1;
      display: flex;
      align-items: center;
    }
    .done-btn {
      height: 0.56rem;
      width: 1.78rem;
      line-height: 0.56rem;
      text-align: center;
      font-size: 0.26rem;
      font-weight: 600;
      color: #282728;
    }
  }

  /deep/ .popMsgBox {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    color: #fff;
    text-align: center;
    font-size: 0.3rem;
    display: flex;
    span {
      margin: auto;
    }
  }
}
</style>
